module.exports = __webpack_public_path__ + "static/media/tan10.fcffcfda.png";